/**
 * Sets the colour of the border.
 * Removes the light and dark paths if a border colour is defined.
 */
Blockly.BlockSvg.prototype.setBorderColour_ = function() {
  var borderColours = this.getColourBorder();
  if (borderColours.colourBorder) {
    this.svgPathLight_.style.display = "none";
    this.svgPathDark_.style.display = "none";
    this.svgPath_.setAttribute("stroke", borderColours.colourBorder);
    // this.svgPath_.setAttribute("stroke", "none");
  } else {
    this.svgPathLight_.style.display = "";
    this.svgPathDark_.style.display = "";
    // this.svgPath_.setAttribute("stroke", borderColours.colourLight);
    this.svgPath_.setAttribute("stroke", "none");

    this.svgPathLight_.setAttribute("stroke", borderColours.colourLight);
    this.svgPathDark_.setAttribute("fill", borderColours.colourDark);
  }
};
import Blockly from "blockly";
/**
 * Sets the colour of the border.
 * Removes the light and dark paths if a border colour is defined.
 */

Blockly.BlockSvg.prototype.setBorderColour_ = function() {
  // debugger;
  var borderColours = this.getColourBorder();
  if (borderColours.colourBorder) {
    this.svgPathLight_.style.display = "none";
    this.svgPathDark_.style.display = "none";
    this.svgPath_.setAttribute("stroke", borderColours.colourBorder); //边框样式修改
    // this.svgPath_.setAttribute("stroke", "none");
  } else {
    this.svgPathLight_.style.display = "";
    this.svgPathDark_.style.display = "";
    // this.svgPath_.setAttribute("stroke", borderColours.colourLight);
    this.svgPath_.setAttribute("stroke", "none");

    // this.svgPathLight_.setAttribute("stroke", borderColours.colourLight);
    this.svgPathDark_.setAttribute("fill", borderColours.colourDark);
  }
};

// Blockly.BlockSvg.prototype.getRelativeToSurfaceXY = function() {
//   var x = 0;
//   var y = 0;

//   var dragSurfaceGroup = this.useDragSurface_
//     ? this.workspace.blockDragSurface_.getGroup()
//     : null;

//   var element = this.getSvgRoot();
//   if (element) {
//     do {
//       // Loop through this block and every parent.
//       var xy = Blockly.utils.getRelativeXY(element);
//       x += xy.x;
//       y += xy.y;
//       // If this element is the current element on the drag surface, include
//       // the translation of the drag surface itself.
//       if (
//         this.useDragSurface_ &&
//         this.workspace.blockDragSurface_.getCurrentBlock() == element
//       ) {
//         var surfaceTranslation = this.workspace.blockDragSurface_.getSurfaceTranslation();
//         x += surfaceTranslation.x;
//         y += surfaceTranslation.y;
//       }
//       element = element.parentNode;
//     } while (
//       element &&
//       element != this.workspace.getCanvas() &&
//       element != dragSurfaceGroup
//     );
//   }
//   debugger;
//   return new Blockly.utils.Coordinate(x, y);
// };
